module.exports = __webpack_public_path__ + "static/images/pencil-filled.66e74543cd97cf1f7b573b5587b69900.svg";